import { render, staticRenderFns } from "./MasterList.vue?vue&type=template&id=0b934272&scoped=true&"
import script from "./MasterList.vue?vue&type=script&lang=js&"
export * from "./MasterList.vue?vue&type=script&lang=js&"
import style1 from "./MasterList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b934272",
  null
  
)

export default component.exports